import {Device} from '../../constants';
import styled from 'styled-components';

export default styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5%;
  position: relative;
  > div {
    flex: 1;
  }
  .ecrfs-left {
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;
    align-self: flex-start;
    @media screen and ${Device.tablet} {
      z-index: 1;
    }
  }
  .ecrfs-right {
    img {
      width: 100%;
    }
    @media screen and ${Device.tablet} {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      opacity: 0.2;
    }
  }
`;
